<div class='step-header row'>
  <div class="col col-100">
    <h3>Sorry, Starry isn’t currently available at your address.</h3>
    <p>Sign up to be among the first to know when we’re in your area.</p>
  </div>
</div>

<div class="card-layout no-border text-dark">
  <div class="row">
    <div class="col col-100">
      <label for="address" class="text-center">Your address:</label>
      <div class="your-address">
        <p>{{#formatPlace address }}{{/formatPlace}}</p>
        <a href="/" class="edit-address">Edit&nbsp;Address</a>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col desktop--col-50 col-100">
      <label for="address-first-name">First Name*</label>
      <input id="address-first-name" value="{{ first_name }}" name="first_name" type="text" autocorrect="off" placeholder="Johnny" autofocus>
    </div>
    <div class="col desktop--col-50 col-100">
      <label for="address-last-name">Last Name*</label>
      <input id="address-last-name" value="{{ last_name }}" name="last_name" type="text" autocorrect="off" placeholder="Appleseed">
    </div>
  </div>
  <div class="row">
    <div class="col col-100">
      <label for="is-building-owner">I am a:*</label>
      <select class="default-disabled" id="is-building-owner"  name="is_building_owner">
        <option value="" disabled selected>Select one</option>
        <option value="false">Resident</option>
        <option value="true">Owner or Manager of this property</option>
      </select>
    </div>
  </div>
  <div class="row">
    <div class="col desktop--col-100 col-100">
      <label for="address-email">Email*</label>
      <input id="address-email" value="{{ email }}" name="email" type="email" autocorrect="off" placeholder="johnny@appleseed.com">
    </div>
  </div>
  <div class="row">
    <div class="col desktop--col-50 col-100">
      <label for="address-apt">Apt/Suite #</label>
      <input id="address-apt" value="{{ address.apt }}" name="address.apt" type="text" autocorrect="off" placeholder="10">
    </div>
    <div class="col desktop--col-50 col-100">
      <label for="address-phone">Phone Number</label>
      <input id="address-phone" value="{{ phone }}" name="phone" type="tel" autocorrect="off" placeholder="555-555-5555">
    </div>
  </div>
  <div class="row">
    <div class="col col-100">
      <label for="address-hdyhau">How did you hear about us?</label>
      <select id="address-hdyhau" name="hdyhau">
        <option value="">Select one</option>
        <option value="search_engine">Search Engine (ex: Google)</option>
        <option value="digital">Digital (ex: Facebook, Instagram, News Article)</option>
        <option value="email">Email</option>
        <option value="building_poster">Poster in my building</option>
        <option value="mail">Mail</option>
        <option value="outdoor_ad">Outdoor Ad (ex: subway, billboard)</option>
        <option value="radio">Radio</option>
        <option value="leasing_team">Leasing Team</option>
        <option value="event">Event</option>
        <option value="friend">Friends/Family</option>
        <option value="tv">TV</option>
        <option value="streaming_podcast">Streaming/Podcast</option>
        <option value="influencer">Influencer</option>
        <option value="other">Other</option>
      </select>
    </div>
  </div>
  <div class="row mt1">
    <div class="col col-100">
      <label class="custom_checkbox label disabled" for="sms_consent">
        <input disabled  type="checkbox" id="sms_consent" name="sms_consent" {{ checked sms_consent true }}>
        <strong>Text me when Starry is available at my address</strong>. Texts may be automated. Carrier message and data rates may apply.
        <span class="checkbox_control"></span>
      </label>
    </div>
  </div>
  <div class="row">
    <input type="submit" class="hidden">
  </div>
</div>
